import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonComponent } from '@lx/shared/ui/button';
import { GoogleAnalyticsClickEventDirective, GoogleAnalyticsService } from '@lx/shared/google-analytics';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';

@Component({
  standalone: true,
  selector: 'lx-juniors-course-upgrade-popup',
  templateUrl: './juniors-course-upgrade-popup.component.html',
  styleUrls: ['./juniors-course-upgrade-popup.component.scss'],
  imports: [DialogModule, ButtonComponent, GoogleAnalyticsClickEventDirective],
})
export class JuniorsCourseUpgradePopupComponent {
  @Input() visible = false;
  @Output() upgradedCourse = new EventEmitter<boolean>();

  quoteUpsellingDenyGAEvent = GoogleAnalyticsEventEnum.QuoteUpsellingDeny;
  quoteUpsellingAcceptGAEvent = GoogleAnalyticsEventEnum.QuoteUpsellingAccept;

  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);

  upgradeJuniorsCourse(value: boolean) {
    this.upgradedCourse.emit(value);
  }

  trackViewEvent() {
    this.googleAnalyticsService.trackViewEvent(GoogleAnalyticsEventEnum.QuoteUpsellingView);
  }
}
